"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = PromoCodeInput;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _humps = require("humps");

var _reactstrap = require("reactstrap");

var _utils = require("@dom/utils");

var _PromocodeProvider = require("./PromocodeProvider");

var _PromocodeApplied = _interopRequireDefault(require("./PromocodeApplied"));

var _Inputs = require("../Inputs");

function PromoCodeInput(props) {
  var invoiceId = props.invoiceId;

  var _React$useState = _react["default"].useState(false),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      on = _React$useState2[0],
      setOn = _React$useState2[1];

  var _React$useState3 = _react["default"].useState(''),
      _React$useState4 = (0, _slicedToArray2["default"])(_React$useState3, 2),
      promocodeInput = _React$useState4[0],
      setPromocodeInput = _React$useState4[1];

  var _React$useState5 = _react["default"].useState(null),
      _React$useState6 = (0, _slicedToArray2["default"])(_React$useState5, 2),
      error = _React$useState6[0],
      setError = _React$useState6[1];

  var _React$useState7 = _react["default"].useState(false),
      _React$useState8 = (0, _slicedToArray2["default"])(_React$useState7, 2),
      isLoading = _React$useState8[0],
      setIsLoading = _React$useState8[1];

  var _usePromocode = (0, _PromocodeProvider.usePromocode)(),
      _usePromocode2 = (0, _slicedToArray2["default"])(_usePromocode, 2),
      promocodeResponse = _usePromocode2[0],
      setPromocodeResponse = _usePromocode2[1];

  function handlePromocode(e) {
    setPromocodeInput(e.target.value);
    if (error) setError(null);
  }

  var toggle = function toggle() {
    return setOn(!on);
  };

  function handleSubmit(_x) {
    return _handleSubmit.apply(this, arguments);
  }

  function _handleSubmit() {
    _handleSubmit = (0, _asyncToGenerator2["default"])(
    /*#__PURE__*/
    _regenerator["default"].mark(function _callee(e) {
      var _ref, data, promocodeWithDiscount;

      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              e.preventDefault();
              setIsLoading(true);
              _context.prev = 2;
              _context.next = 5;
              return _utils.api.postWithoutToken('payments/promocode/verify', {
                invoice_id: invoiceId,
                promocode: promocodeInput.trim()
              });

            case 5:
              _ref = _context.sent;
              data = _ref.data;
              promocodeWithDiscount = (0, _humps.camelizeKeys)(data);
              setPromocodeResponse(promocodeWithDiscount);
              toggle();
              _context.next = 15;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](2);
              setError(_context.t0.response.data.message);

            case 15:
              _context.prev = 15;
              setIsLoading(false);
              return _context.finish(15);

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 12, 15, 18]]);
    }));
    return _handleSubmit.apply(this, arguments);
  }

  var isPromocodeApplied = Boolean(promocodeResponse);

  if (isPromocodeApplied) {
    return _react["default"].createElement(_PromocodeApplied["default"], {
      promocode: promocodeResponse.promocode,
      onDelete: function onDelete() {
        return setPromocodeResponse(null);
      }
    });
  }

  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("span", {
    tabIndex: "0",
    role: "button",
    onClick: toggle,
    onKeyDown: toggle,
    className: "promo-ent",
    id: "guides-enter-HG-credit-btn"
  }, "Enter HoneyGuide Credits"), _react["default"].createElement(_reactstrap.Modal, {
    isOpen: on,
    toggle: toggle,
    className: "flight_modal"
  }, _react["default"].createElement(_reactstrap.ModalHeader, {
    toggle: toggle
  }, "Enter HoneyGuide Credits"), _react["default"].createElement("form", {
    onSubmit: handleSubmit
  }, _react["default"].createElement(_reactstrap.InputGroup, null, _react["default"].createElement(_reactstrap.Input, {
    type: "text",
    value: promocodeInput,
    onChange: handlePromocode,
    "aria-label": "Enter HoneyGuide Credits"
  }), _react["default"].createElement(_reactstrap.InputGroupAddon, {
    addonType: "append",
    className: "promo"
  }, _react["default"].createElement(_reactstrap.Button, {
    color: "yellow",
    id: "guides-apply-hg-credit-btn",
    onClick: handleSubmit,
    disabled: !promocodeInput,
    className: isLoading ? 'btn-loading' : ''
  }, isLoading ? 'APPLYING CREDIT' : 'APPLY CREDIT'))), _react["default"].createElement(_Inputs.Error, {
    error: error
  }))));
}